import { useEffect, useState } from "react";
import { AsyncCallArgs, Country, Settlement, useAsyncCall } from "@duosoftbg/nacid-components";
import { getSettlement } from "../../../../axios/api/services";

type UserBirthPlaceProps = {
  country: Country;
  settlement: Settlement;
  city: string;
};

const useUserBirthPlace = ({ country, settlement, city }: UserBirthPlaceProps) => {
  const { asyncCall } = useAsyncCall();

  const isBG = country?.id === "BG";
  const settlementId = settlement?.id;
  const [settlementName, setSettlementName] = useState(null);

  useEffect(() => {
    if (isBG && settlementId) {
      const fetchSettlementCallArgs: AsyncCallArgs = {
        promise: getSettlement(settlementId),
        withGlobalBackdrop: false,
        processResponseErrors: false,
        onSuccess: (response) => {
          setSettlementName(response.fullSettlementName);
        },
        onError: (err) => {
          setSettlementName(null);
        },
      };
      asyncCall(fetchSettlementCallArgs);
    }
  }, [asyncCall, isBG, settlementId]);

  const selectBirthPlace = () => {
    if (isBG && settlementName) {
      return settlementName;
    } else {
      return city;
    }
  };

  return { birthPlace: selectBirthPlace() };
};

export default useUserBirthPlace;
